import { render, staticRenderFns } from "./SiteNotificationElement.vue?vue&type=template&id=f70412b0"
import script from "./SiteNotificationElement.vue?vue&type=script&lang=js"
export * from "./SiteNotificationElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports